import { render } from "./GoalListFull.vue?vue&type=template&id=4bdbb587&scoped=true"
import script from "./GoalListFull.vue?vue&type=script&lang=js"
export * from "./GoalListFull.vue?vue&type=script&lang=js"

import "./GoalListFull.vue?vue&type=style&index=0&id=4bdbb587&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdbb587"]])

export default __exports__